import { useContext } from 'react'

import { TutorialSettingsContext } from './tutorial-settings.context'

const useTutorialSettings = () => useContext(TutorialSettingsContext)

export default useTutorialSettings
